import { render } from "./DetalhesPedidoExpedidoFaturado.vue?vue&type=template&id=55c5a035&scoped=true"
import script from "./DetalhesPedidoExpedidoFaturado.vue?vue&type=script&lang=js"
export * from "./DetalhesPedidoExpedidoFaturado.vue?vue&type=script&lang=js"

import "./DetalhesPedidoExpedidoFaturado.vue?vue&type=style&index=0&id=55c5a035&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c5a035"]])

export default __exports__